import { useCallback } from 'react';

import { useDataLayerContext } from '~/utilities/context/static/DataLayerContext';
import type { Product } from '~/utilities/graphql/codegen';
import { getProductDataLayerEvent } from '~/utilities/vendors';
import type { ProductClickViewType, SectionNameType } from '~/utilities/vendors/dataLayer.type';

type Props = {
  product: Product;
  position: number;
  sectionName: SectionNameType;
};

export const useEecProductClickEvent = ({ product, position, sectionName }: Props) => {
  const { pushToDataLayer } = useDataLayerContext();

  const pushDataLayerEvent = useCallback(
    (viewType: ProductClickViewType) => {
      const eecProductClickEvent = getProductDataLayerEvent('eecProductClick', {
        product,
        position,
        sectionName,
        viewType,
      });

      if (eecProductClickEvent) {
        pushToDataLayer(eecProductClickEvent);
      }
    },
    [position, product, pushToDataLayer, sectionName]
  );

  return pushDataLayerEvent;
};
